exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".addsensor-dialog {\n  max-width: 900px !important;\n  width: 100% !important;\n}", "",{"version":3,"sources":["Sensor.scss"],"names":[],"mappings":"AAAA;EACC,2BAAA;EACA,sBAAA;AACD","file":"Sensor.scss","sourcesContent":[".addsensor-dialog {\r\n\tmax-width: 900px !important;\r\n\twidth: 100% !important;\r\n}\r\n"]}]);

